import { render, staticRenderFns } from "./Draw.vue?vue&type=template&id=1b3d1dcf"
import script from "./Draw.vue?vue&type=script&lang=js"
export * from "./Draw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports